<template>
  <!-- D: 회원가입, 로그인 전용 레이아웃 layout-member -->
  <div class="l-content-inner">
    <!-- 로그인 & 회원가입 -->
    <div class="p-member-wrap">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">노루페인트 PAINT PRO 회원가입</h1>
      </div>

      <div class="c-process">
        <ol>
          <!-- D: 현재 단계 is-current 추가 -->
          <li class="is-current" aria-current="step">
            <span class="step-circle"></span>
            <span class="text">약관동의</span>
          </li>
          <li>
            <span class="step-circle"></span>
            <span class="text">정보입력</span>
          </li>
          <li>
            <span class="step-circle"></span>
            <span class="text">가입완료</span>
          </li>
        </ol>
      </div>

      <form action="">
        <div class="terms-box">
          <h2 class="c-title-level3">
            <b class="color-primary">[필수]</b>
            이용약관
          </h2>
          <TermAgreeement1 />
          <div class="c-check-field flex-ar">
            <div
              class="c-radio"
              :class="{ 'type-required': agreement1Required }"
            >
              <input
                type="radio"
                :id="agreement1_1Id"
                name="radiogroup"
                value="disagree"
                v-model="agreement1"
                @change="() => (agreement1Required = false)"
              />
              <label :for="agreement1_1Id">동의하지 않음</label>
            </div>
            <div
              class="c-radio"
              :class="{ 'type-required': agreement1Required }"
            >
              <input
                type="radio"
                :id="agreement1_2Id"
                name="radiogroup"
                value="agree"
                v-model="agreement1"
                @change="() => (agreement1Required = false)"
              />
              <label :for="agreement1_2Id">동의함</label>
            </div>
          </div>
        </div>

        <div class="terms-box">
          <h2 class="c-title-level3">
            <b class="color-primary">[필수]</b>
            개인정보 수집 및 이용 동의
          </h2>
          <TermAgreeement2 />
          <div class="c-check-field flex-ar">
            <div
              class="c-radio"
              :class="{ 'type-required': agreement2Required }"
            >
              <input
                type="radio"
                :id="agreement2_1Id"
                name="radiogroup2"
                value="disagree"
                v-model="agreement2"
                @change="() => (agreement2Required = false)"
              />
              <label :for="agreement2_1Id">동의하지 않음</label>
            </div>
            <div
              class="c-radio"
              :class="{ 'type-required': agreement2Required }"
            >
              <input
                type="radio"
                :id="agreement2_2Id"
                name="radiogroup2"
                value="agree"
                v-model="agreement2"
                @change="() => (agreement2Required = false)"
              />
              <label :for="agreement2_2Id">동의함</label>
            </div>
          </div>
        </div>

        <div class="c-btn-area">
          <button
            type="button"
            class="c-button type-secondary"
            @click="goToLogin"
          >
            <span>가입취소</span>
          </button>
          <button type="button" class="c-button type-primary" @click="nextStep">
            <span>다음 단계</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup name="join_Term">
import TermAgreeement1 from "./TermAgreement1.vue";
import TermAgreeement2 from "./TermAgreement2.vue";
import { ref, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { v4 as uuidv4 } from "uuid";
import * as cmUtil from "@/utils/cmUtil";

const router = useRouter();

const emits = defineEmits(["login", "next"]);

const agreement1 = ref(null);
const agreement2 = ref(null);

const agreement1_1Id = uuidv4();
const agreement1_2Id = uuidv4();
const agreement2_1Id = uuidv4();
const agreement2_2Id = uuidv4();

const agreement1Required = ref(false);
const agreement2Required = ref(false);

const nextStep = () => {
  if (!checkValidate()) {
    cmUtil.alert("약관에 동의해 주세요.");
    return;
  }

  emits("next");
};

const checkValidate = () => {
  let validated = true;

  if (agreement1.value !== "agree") {
    agreement1Required.value = true;
    validated = false;
  }

  if (agreement2.value !== "agree") {
    agreement2Required.value = true;
    validated = false;
  }

  return validated;
};

const goToLogin = () => {
  router.push("/");
};
</script>
